/**
 * MODULE: _shared/frontend/components/layout/ThreeColumnThreadShell.tsx
 * PURPOSE: Reusable 300px | 1fr | 52px grid for inbox (domain/email) and internal chat (Phase 2).
 * DEPENDENCIES: react
 * AGENT_SAFETY: 🟢 SAFE
 */

import React, { type ReactNode } from 'react';
import './three-column-thread-shell.css';

export interface ThreeColumnThreadShellProps {
  /** Left column — thread / conversation list */
  sidebar: ReactNode;
  /** Center — detail / message stream */
  main: ReactNode;
  /** Right rail — icon actions */
  rail: ReactNode;
  /** Optional class on the root grid (e.g. slice-specific theming) */
  className?: string;
  /** Accessible label for the layout region */
  'aria-label'?: string;
}

export function ThreeColumnThreadShell({
  sidebar,
  main,
  rail,
  className = '',
  'aria-label': ariaLabel = 'Three-column messaging layout',
}: ThreeColumnThreadShellProps) {
  const rootClass = ['three-column-thread-shell', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass} role="region" aria-label={ariaLabel}>
      <div className="three-column-thread-shell__sidebar">{sidebar}</div>
      <div className="three-column-thread-shell__main">{main}</div>
      <div className="three-column-thread-shell__rail">{rail}</div>
    </div>
  );
}
